<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <v-container>
      <v-layout wrap="">
        <v-flex xs12 sm6 md2>
          <v-text-field
            disabled
            v-model="mycode"
            label=" رقم اذن السداد من الخزينة"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md2>
          <v-text-field
            @keyup.enter="search_importer_by_code"
            v-model="searchimporterCode"
            label="كودالمورد"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md4>
          <v-autocomplete
            v-model="select_importer"
            :items="importers"
            item-text="name"
            item-value="id"
            label="أختر المورد"
            persistent-hint
            return-object
            single-line
            @change="get_all_info"
          >
            <template v-slot:append-outer>
              <v-slide-x-reverse-transition mode="out-in">
              </v-slide-x-reverse-transition>
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex xs12 sm6 md4>
          <v-autocomplete
            v-model="select_khazna"
            :items="khazinas"
            item-text="name"
            item-value="id"
            label=" أختر الخزينة "
            persistent-hint
            return-object
            single-line
            @change="get_khazina"
          >
            <template v-slot:append-outer>
              <v-slide-x-reverse-transition mode="out-in">
              </v-slide-x-reverse-transition>
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex xs12 sm6 md2>
          <v-text-field
            disabled
            v-model="select_khazna.rasid"
            type="number"
            label="رصيد الخزينة"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md2>
          <v-text-field
            v-model="money"
            type="number"
            label="المبلغ"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md2>
          <v-text-field
            disabled
            v-model="the_madionia"
            label="المديونية"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm8 md8>
          <v-textarea v-model="comment" rows="2" label="ملاحظات"></v-textarea>
        </v-flex>
        <v-flex xs12 sm6 md2>
          <v-dialog
            ref="dialog2"
            v-model="modal2"
            :return-value.sync="date2"
            persistent
            lazy
            full-width
            width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="date2"
                label=" التاريخ اليدوي"
                readonly
                outline
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="date2" scrollable>
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="modal2 = false">Cancel</v-btn>
              <v-btn flat color="primary" @click="$refs.dialog2.save(date2)"
                >OK</v-btn
              >
            </v-date-picker>
          </v-dialog>
        </v-flex>
        <v-flex xs12 sm6 md2>
          <v-btn @click="add_sadad">Add</v-btn>
        </v-flex>
      </v-layout>
      <div v-if="fatworas.length > 0">
        الفواتير الغير مسددة
        <v-data-table
          :headers="headers"
          :items="fatworas"
          class="elevation-1"
          :rows-per-page-items="rowsPerPageItems"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.code }}</td>
            <td class="text-xs-right">{{ props.item.final_price }}</td>
            <td class="text-xs-right">{{ props.item.remain }}</td>
            <td class="text-xs-right">{{ props.item.sdad_status }}</td>
            <td class="text-xs-right">{{ props.item.sdad_type_name }}</td>
          </template>
        </v-data-table>
      </div>
      <div v-else>لا يوجد فواتير غير مسددة</div>

      <br />
      <p>مجموع السدادات لجميع الخزائن : {{ total_of_all_khaznas }}</p>
      <p>مجموع السدادات لهذه الخزنة فقط : {{ total }}</p>

      <v-toolbar flat color="white">
        <v-toolbar-title> جميع السدادات السابقة</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="البحث"
          single-line
          hide-details
        ></v-text-field>
      </v-toolbar>

      <v-data-table
        :headers="headers2"
        :items="sadads_fatworas"
        class="elevation-1"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <tr
            :style="[
              props.item.status === '0'
                ? { 'background-color': '#D4B1B1' }
                : { 'background-color': '#fff' }
            ]"
          >
            <td class="text-xs-right">
              {{ props.item.importer ? props.item.importer.name : "" }}
            </td>
            <td>{{ props.item.money_q }}</td>
            <!-- <td class="text-xs-right">{{ props.item.madionia_before }}</td>
          <td class="text-xs-right">{{ props.item.madionia_after }}</td>
          <td class="text-xs-right">{{ props.item.fatwora_importer ? props.item.fatwora_importer.code : '' }}</td> -->
            <td class="text-xs-right">{{ props.item.created_at }}</td>
            <td class="text-xs-right">
              <v-btn
                v-if="permissions.delete_all == 1 || user.type == 1"
                @click="delete_importer_sadad(props.item)"
                >حذف</v-btn
              >
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
        <template slot="no-data">
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination
          dark
          dir="rtl"
          class="mypagination"
          v-model="pagination.page"
          :length="pages"
          prev-icon="chevron_right"
          next-icon="chevron_left"
        ></v-pagination>
      </div>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import {
  importers,
  search_importer_by_code,
  khazina_importer_sadads,
  khazinas,
  khazna_fatworas,
  add_importer_sadad,
  get_all_info_of_importer,
  delete_importer_sadad
} from "../config/apiRoute.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    rowsPerPageItems: [400, 800],
    add_dialog: false,
    edit_dialog: false,
    headers: [
      {
        text: " الكود",
        align: "right",
        value: "name",
        sortable: false
      },
      { text: " السعر", value: "address", sortable: false, align: "right" },
      { text: " المتبقي", value: "address", sortable: false, align: "right" },
      { text: " حالة السداد", value: "rasid", sortable: false, align: "right" },
      { text: " نوع السداد", value: "rasid", sortable: false, align: "right" }
    ],
    headers2: [
      { text: "اسم المورد", value: "importer.name", align: "right" },
      {
        text: " المبلغ",
        align: "right",
        value: "money_q"
      },
      // { text: " المديونية السابقة", value: "madionia_before",  align: "right" },
      // { text: " المديونية بعد", value: "madionia_after",  align: "right" },
      // { text: "كود فاتورة المشتريات", value: "fatwora_importer.code",  align: "right" },
      { text: "التاريخ", value: "created_at", align: "right" },
      { text: "حذف", value: "delete", align: "right" }
    ],
    menu2: false,
    dialog2: false,
    modal2: false,
    date2: new Date().toISOString().substr(0, 10),
    select_importer: { id: "" },
    select_khazna: { id: "" },
    search: "",
    comment: "",
    loading: true,
    sadads_fatworas: [],
    total: 0,
    total_of_all_khaznas: 0,
    khazina_fatworas: [],
    pagination: {
      rowsPerPage: 30,
      descending: true
    },
    importers: [],
    fatworas: [],
    khazinas: [],
    all_importer_fatworas: [],
    all_importer_sadads: [],
    theKhazna: {},
    money: "",
    searchimporterCode: "",
    madionia_sabqa: "",
    madionia_sabqa_of_madionia: "",
    importer_sadad_table1: {
      money_q: "",
      note: "",
      madionia_before: "",
      madionia_after: "",
      emp_name: "",
      emp_id: "",
      khazina_id: "",
      importer_id: "",
      fatwora_importers_id: "",
      created_at: ""
    },
    importer_sadad_table2: {
      money_q: "",
      note: "",
      madionia_before: "",
      madionia_after: "",
      emp_name: "",
      emp_id: "",
      khazina_id: "",
      importer_id: "",
      fatwora_importers_id: "",
      created_at: ""
    },
    importer_sadad_table3: {
      money_q: "",
      note: "",
      madionia_before: "",
      madionia_after: "",
      emp_name: "",
      emp_id: "",
      khazina_id: "",
      importer_id: "",
      fatwora_importers_id: "",
      created_at: ""
    },
    khazna_fatwora_table: {
      code: "",
      emp_name: "",
      rasid_before: "",
      money: "",
      rasid_after: "",
      type: "",
      notes: "",
      khazina_id: "",
      action: "",
      created_at: ""
    },
    madionia_importer_table: {
      madionia_before: "",
      cost_or_money: "",
      madionia_after: "",
      emp_name: "",
      type_of_operation: "",
      code_of_operation: "",
      importer_id: "",
      emp_id: "",
      created_at: ""
    },
    fatwora_importer_update1: {
      id: "",
      remain: "",
      sdad_status: "",
      sdad_status_id: ""
    },
    fatwora_importer_update2: {
      id: "",
      remain: "",
      sdad_status: "",
      sdad_status_id: ""
    },
    fatwora_importer_update3: {
      id: "",
      remain: "",
      sdad_status: "",
      sdad_status_id: ""
    },
    khazina_update: {
      id: "",
      rasid: ""
    },
    the_madionia: 0
  }),

  computed: {
    mycode() {
      if (this.khazina_fatworas.length > 0) {
        return (this.code =
          parseInt(
            this.khazina_fatworas[this.khazina_fatworas.length - 1].code
          ) + 1);
      } else {
        return (this.code = 1000);
      }
    },
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
  },

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
    this.initialize();
  },

  methods: {
    initialize() {
      importers().then(response => {
        this.importers = response.data;
        this.loading = false;
      });

      khazinas(0).then(response => {
        this.khazinas = response.data;
      });

      khazna_fatworas().then(response => {
        this.khazina_fatworas = response.data;
      });
    },

    search_importer_by_code() {
      search_importer_by_code(this.searchimporterCode).then(response => {
        this.select_importer = response.data;
        this.get_all_info();
      });
    },
    get_all_info() {
      this.loading = true;
      this.searchimporterCode = this.select_importer.code;
      this.fatworas = [];
      this.the_madionia = 0;
      this.total_of_all_khaznas = 0;
      get_all_info_of_importer(this.select_importer.id).then(res => {
        this.fatworas = res.data.fatworas_no_sadad;
        this.the_madionia = res.data.madionia;
        this.total_of_all_khaznas = res.data.total_of_sadads_all_khaznas;
        this.loading = false;
      });
    },
    get_khazina() {
      khazina_importer_sadads(this.select_khazna.id).then(response => {
        this.theKhazna = response.data.khazina;
        this.sadads_fatworas = response.data.sadads;
        this.pagination.totalItems = response.data.sadads.length;
        this.total = response.data.total;
      });
    },

    close() {
      this.add_dialog = false;
      this.edit_dialog = false;
      //   setTimeout(() => {
      //     this.editedItem = Object.assign({}, this.defaultItem)
      //     this.editedIndex = -1
      //   }, 300)
    },

    add_sadad() {
      if (
        this.select_importer.id != "" &&
        this.money != "" &&
        this.select_khazna.id != ""
      ) {
        if (parseFloat(this.select_khazna.rasid) >= parseFloat(this.money)) {
          // if(parseFloat(this.money) <= parseFloat(this.select_khazna.rasid)){
          let myUser = JSON.parse(localStorage.getItem("user"));

          this.khazna_fatwora_table.code = this.mycode;
          this.khazna_fatwora_table.emp_name = myUser.name;
          this.khazna_fatwora_table.rasid_before = this.theKhazna.rasid;
          this.khazna_fatwora_table.money = this.money;
          this.khazna_fatwora_table.rasid_after =
            parseFloat(this.theKhazna.rasid) - parseFloat(this.money);
          this.khazna_fatwora_table.type = "out";
          this.khazna_fatwora_table.action = "importer_sadad";
          this.khazna_fatwora_table.notes = this.comment;
          this.khazna_fatwora_table.khazina_id = this.select_khazna.id;
          this.khazna_fatwora_table.created_at = this.date2;

          this.madionia_importer_table.madionia_before = this.madionia_sabqa;
          this.madionia_importer_table.cost_or_money = this.money;
          this.madionia_importer_table.madionia_after =
            parseFloat(this.madionia_sabqa) - parseFloat(this.money);
          this.madionia_importer_table.emp_name = myUser.name;
          this.madionia_importer_table.type_of_operation = "sadad";
          this.madionia_importer_table.code_of_operation = this.khazna_fatwora_table.code;
          this.madionia_importer_table.importer_id = this.select_importer.id;
          this.madionia_importer_table.emp_id = myUser.id;
          this.madionia_importer_table.created_at = this.date2;

          this.importer_sadad_table1.note = this.comment;
          this.importer_sadad_table1.madionia_before = this.madionia_sabqa;
          this.importer_sadad_table1.emp_name = myUser.name;
          this.importer_sadad_table1.emp_id = myUser.id;
          this.importer_sadad_table1.khazina_id = this.select_khazna.id;
          this.importer_sadad_table1.importer_id = this.select_importer.id;
          this.importer_sadad_table1.created_at = this.date2;

          this.importer_sadad_table2.note = this.comment;
          this.importer_sadad_table2.emp_name = myUser.name;
          this.importer_sadad_table2.emp_id = myUser.id;
          this.importer_sadad_table2.khazina_id = this.select_khazna.id;
          this.importer_sadad_table2.importer_id = this.select_importer.id;
          this.importer_sadad_table2.created_at = this.date2;

          this.importer_sadad_table3.note = this.comment;
          this.importer_sadad_table3.emp_name = myUser.name;
          this.importer_sadad_table3.emp_id = myUser.id;
          this.importer_sadad_table3.khazina_id = this.select_khazna.id;
          this.importer_sadad_table3.importer_id = this.select_importer.id;
          this.importer_sadad_table3.created_at = this.date2;

          this.khazina_update.id = this.theKhazna.id;
          this.khazina_update.rasid =
            parseFloat(this.theKhazna.rasid) - parseFloat(this.money);

          if (parseFloat(this.money) > parseFloat(this.the_madionia)) {
            alert("المبلغ المسدد اكبر من المديونية ");
          } else {
            if (this.fatworas.length > 0) {
              if (
                parseFloat(this.money) >= parseFloat(this.fatworas[0].remain)
              ) {
                if (this.fatworas[1]) {
                  if (
                    parseFloat(this.money) >=
                    parseFloat(this.fatworas[0].remain) +
                      parseFloat(this.fatworas[1].remain)
                  ) {
                    if (this.fatworas[2]) {
                      // importer sadad array[0]
                      var remain_to_second_fatwora =
                        parseFloat(this.money) -
                        parseFloat(this.fatworas[0].remain);
                      this.importer_sadad_table1.fatwora_importers_id = this.fatworas[0].id;
                      this.importer_sadad_table1.money_q = this.fatworas[0].remain;
                      this.importer_sadad_table1.madionia_after =
                        parseFloat(this.madionia_sabqa) -
                        parseFloat(this.fatworas[0].remain);
                      // this.push_importer_sadad(this.importer_sadad_table)
                      this.all_importer_sadads[0] = this.importer_sadad_table1;

                      // importer sadad array[1]
                      var remain_to_third_fatwora =
                        parseFloat(remain_to_second_fatwora) -
                        parseFloat(this.fatworas[1].remain);
                      this.importer_sadad_table2.fatwora_importers_id = this.fatworas[1].id;
                      this.importer_sadad_table2.madionia_before = this.importer_sadad_table1.madionia_after;
                      this.importer_sadad_table2.money_q = this.fatworas[1].remain;
                      this.importer_sadad_table2.madionia_after =
                        this.importer_sadad_table1.madionia_after -
                        parseFloat(this.fatworas[1].remain);
                      // this.all_importer_sadads.push(importer_sadad_table2)
                      this.all_importer_sadads[1] = this.importer_sadad_table2;

                      // importer sadad array[2]
                      this.importer_sadad_table3.fatwora_importers_id = this.fatworas[2].id;
                      this.importer_sadad_table3.madionia_before = this.importer_sadad_table2.madionia_after;
                      this.importer_sadad_table3.money_q = remain_to_third_fatwora;
                      this.importer_sadad_table3.madionia_after =
                        this.importer_sadad_table2.madionia_after -
                        parseFloat(remain_to_third_fatwora);
                      // this.all_importer_sadads.push(importer_sadad_table2)
                      this.all_importer_sadads[2] = this.importer_sadad_table3;

                      // fatwora importer array[0]
                      this.fatwora_importer_update1.id = this.fatworas[0].id;
                      this.fatwora_importer_update1.remain = "0";
                      this.fatwora_importer_update1.sdad_status = "تم السداد";
                      this.fatwora_importer_update1.sdad_status_id = "3";
                      this.all_importer_fatworas.push(
                        this.fatwora_importer_update1
                      );

                      // fatwora importer array[1]
                      this.fatwora_importer_update2.id = this.fatworas[1].id;
                      this.fatwora_importer_update2.remain = "0";
                      this.fatwora_importer_update2.sdad_status = "تم السداد";
                      this.fatwora_importer_update2.sdad_status_id = "3";
                      this.all_importer_fatworas.push(
                        this.fatwora_importer_update2
                      );

                      // fatwora importer array[2]
                      this.fatwora_importer_update3.id = this.fatworas[2].id;
                      this.fatwora_importer_update3.remain =
                        parseFloat(this.fatworas[1].remain) -
                        parseFloat(remain_to_third_fatwora);
                      this.fatwora_importer_update3.sdad_status = "جاري السداد";
                      this.fatwora_importer_update3.sdad_status_id = "2";
                      this.all_importer_fatworas.push(
                        this.fatwora_importer_update3
                      );

                      let khazna_fatwora_ = JSON.stringify(
                        this.khazna_fatwora_table
                      );
                      let madionia_importer_ = JSON.stringify(
                        this.madionia_importer_table
                      );
                      let importer_sadad_ = JSON.stringify(
                        this.all_importer_sadads
                      );
                      let importer_fatworas_ = JSON.stringify(
                        this.all_importer_fatworas
                      );
                      let khazina_ = JSON.stringify(this.khazina_update);

                      this.do_sadad(
                        khazna_fatwora_,
                        madionia_importer_,
                        importer_sadad_,
                        importer_fatworas_,
                        khazina_
                      );
                    } else {
                      // importer sadad array[0]
                      var remain_to_second_fatwora =
                        parseFloat(this.money) -
                        parseFloat(this.fatworas[0].remain);
                      this.importer_sadad_table1.fatwora_importers_id = this.fatworas[0].id;
                      this.importer_sadad_table1.money_q = this.fatworas[0].remain;
                      this.importer_sadad_table1.madionia_after =
                        parseFloat(this.madionia_sabqa) -
                        parseFloat(this.fatworas[0].remain);
                      // this.push_importer_sadad(this.importer_sadad_table)
                      this.all_importer_sadads[0] = this.importer_sadad_table1;

                      // importer sadad array[1]
                      this.importer_sadad_table2.fatwora_importers_id = this.fatworas[1].id;
                      this.importer_sadad_table2.madionia_before = this.importer_sadad_table1.madionia_after;
                      this.importer_sadad_table2.money_q = remain_to_second_fatwora;
                      this.importer_sadad_table2.madionia_after =
                        this.importer_sadad_table1.madionia_after -
                        parseFloat(remain_to_second_fatwora);
                      // this.all_importer_sadads.push(importer_sadad_table2)
                      this.all_importer_sadads[1] = this.importer_sadad_table2;

                      // fatwora importer array[0]
                      this.fatwora_importer_update1.id = this.fatworas[0].id;
                      this.fatwora_importer_update1.remain = "0";
                      this.fatwora_importer_update1.sdad_status = "تم السداد";
                      this.fatwora_importer_update1.sdad_status_id = "3";
                      this.all_importer_fatworas.push(
                        this.fatwora_importer_update1
                      );

                      // fatwora importer array[1]
                      this.fatwora_importer_update2.id = this.fatworas[1].id;
                      this.fatwora_importer_update2.remain =
                        parseFloat(this.fatworas[1].remain) -
                        parseFloat(remain_to_second_fatwora);
                      this.fatwora_importer_update2.sdad_status = "تم السداد";
                      this.fatwora_importer_update2.sdad_status_id = "3";
                      this.all_importer_fatworas.push(
                        this.fatwora_importer_update2
                      );

                      let khazna_fatwora_ = JSON.stringify(
                        this.khazna_fatwora_table
                      );
                      let madionia_importer_ = JSON.stringify(
                        this.madionia_importer_table
                      );
                      let importer_sadad_ = JSON.stringify(
                        this.all_importer_sadads
                      );
                      let importer_fatworas_ = JSON.stringify(
                        this.all_importer_fatworas
                      );
                      let khazina_ = JSON.stringify(this.khazina_update);

                      this.do_sadad(
                        khazna_fatwora_,
                        madionia_importer_,
                        importer_sadad_,
                        importer_fatworas_,
                        khazina_
                      );
                    }
                  } else {
                    // mean is more than first but least than addition 1 + 2 so send twice

                    // importer sadad array[0]
                    var remain_to_second_fatwora =
                      parseFloat(this.money) -
                      parseFloat(this.fatworas[0].remain);
                    this.importer_sadad_table1.fatwora_importers_id = this.fatworas[0].id;
                    this.importer_sadad_table1.money_q = this.fatworas[0].remain;
                    this.importer_sadad_table1.madionia_after =
                      parseFloat(this.madionia_sabqa) -
                      parseFloat(this.fatworas[0].remain);
                    // this.push_importer_sadad(this.importer_sadad_table)
                    this.all_importer_sadads[0] = this.importer_sadad_table1;

                    // importer sadad array[1]
                    this.importer_sadad_table2.fatwora_importers_id = this.fatworas[1].id;
                    this.importer_sadad_table2.madionia_before = this.importer_sadad_table1.madionia_after;
                    this.importer_sadad_table2.money_q = remain_to_second_fatwora;
                    this.importer_sadad_table2.madionia_after =
                      this.importer_sadad_table1.madionia_after -
                      parseFloat(remain_to_second_fatwora);
                    // this.all_importer_sadads.push(importer_sadad_table2)
                    this.all_importer_sadads[1] = this.importer_sadad_table2;

                    // fatwora importer array[0]
                    this.fatwora_importer_update1.id = this.fatworas[0].id;
                    this.fatwora_importer_update1.remain = "0";
                    this.fatwora_importer_update1.sdad_status = "تم السداد";
                    this.fatwora_importer_update1.sdad_status_id = "3";
                    this.all_importer_fatworas.push(
                      this.fatwora_importer_update1
                    );

                    // fatwora importer array[1]
                    this.fatwora_importer_update2.id = this.fatworas[1].id;
                    this.fatwora_importer_update2.remain =
                      parseFloat(this.fatworas[1].remain) -
                      parseFloat(remain_to_second_fatwora);
                    this.fatwora_importer_update2.sdad_status = "جاري السداد";
                    this.fatwora_importer_update2.sdad_status_id = "2";
                    this.all_importer_fatworas.push(
                      this.fatwora_importer_update2
                    );

                    let khazna_fatwora_ = JSON.stringify(
                      this.khazna_fatwora_table
                    );
                    let madionia_importer_ = JSON.stringify(
                      this.madionia_importer_table
                    );
                    let importer_sadad_ = JSON.stringify(
                      this.all_importer_sadads
                    );
                    let importer_fatworas_ = JSON.stringify(
                      this.all_importer_fatworas
                    );
                    let khazina_ = JSON.stringify(this.khazina_update);

                    this.do_sadad(
                      khazna_fatwora_,
                      madionia_importer_,
                      importer_sadad_,
                      importer_fatworas_,
                      khazina_
                    );
                  }
                } else {
                  if (
                    parseFloat(this.money) ==
                    parseFloat(this.fatworas[0].remain)
                  ) {
                    // importer sadad array[0]
                    var remain_to_first_fatwora =
                      parseFloat(this.fatworas[0].remain) -
                      parseFloat(this.money);
                    this.importer_sadad_table1.fatwora_importers_id = this.fatworas[0].id;
                    this.importer_sadad_table1.money_q = this.money;
                    this.importer_sadad_table1.madionia_after =
                      parseFloat(this.madionia_sabqa) - parseFloat(this.money);
                    // this.push_importer_sadad(this.importer_sadad_table)
                    this.all_importer_sadads[0] = this.importer_sadad_table1;

                    // fatwora importer array[0]
                    this.fatwora_importer_update1.id = this.fatworas[0].id;
                    this.fatwora_importer_update1.remain = remain_to_first_fatwora;
                    this.fatwora_importer_update1.sdad_status = "تم السداد";
                    this.fatwora_importer_update1.sdad_status_id = "3";
                    this.all_importer_fatworas.push(
                      this.fatwora_importer_update1
                    );

                    let khazna_fatwora_ = JSON.stringify(
                      this.khazna_fatwora_table
                    );
                    let madionia_importer_ = JSON.stringify(
                      this.madionia_importer_table
                    );
                    let importer_sadad_ = JSON.stringify(
                      this.all_importer_sadads
                    );
                    let importer_fatworas_ = JSON.stringify(
                      this.all_importer_fatworas
                    );
                    let khazina_ = JSON.stringify(this.khazina_update);

                    this.do_sadad(
                      khazna_fatwora_,
                      madionia_importer_,
                      importer_sadad_,
                      importer_fatworas_,
                      khazina_
                    );
                  } else {
                    // importer sadad array[0]
                    var remain_to_first_fatwora =
                      parseFloat(this.fatworas[0].remain) -
                      parseFloat(this.money);
                    this.importer_sadad_table1.fatwora_importers_id = this.fatworas[0].id;
                    this.importer_sadad_table1.money_q = this.money;
                    this.importer_sadad_table1.madionia_after =
                      parseFloat(this.madionia_sabqa) - parseFloat(this.money);
                    // this.push_importer_sadad(this.importer_sadad_table)
                    this.all_importer_sadads[0] = this.importer_sadad_table1;

                    // fatwora importer array[0]
                    this.fatwora_importer_update1.id = this.fatworas[0].id;
                    this.fatwora_importer_update1.remain = remain_to_first_fatwora;
                    this.fatwora_importer_update1.sdad_status = "جاري السداد";
                    this.fatwora_importer_update1.sdad_status_id = "2";
                    this.all_importer_fatworas.push(
                      this.fatwora_importer_update1
                    );

                    let khazna_fatwora_ = JSON.stringify(
                      this.khazna_fatwora_table
                    );
                    let madionia_importer_ = JSON.stringify(
                      this.madionia_importer_table
                    );
                    let importer_sadad_ = JSON.stringify(
                      this.all_importer_sadads
                    );
                    let importer_fatworas_ = JSON.stringify(
                      this.all_importer_fatworas
                    );
                    let khazina_ = JSON.stringify(this.khazina_update);

                    this.do_sadad(
                      khazna_fatwora_,
                      madionia_importer_,
                      importer_sadad_,
                      importer_fatworas_,
                      khazina_
                    );
                  }
                }
              } else {
                // importer sadad array[0]
                var remain_to_first_fatwora =
                  parseFloat(this.fatworas[0].remain) - parseFloat(this.money);
                this.importer_sadad_table1.fatwora_importers_id = this.fatworas[0].id;
                this.importer_sadad_table1.money_q = this.money;
                this.importer_sadad_table1.madionia_after =
                  parseFloat(this.madionia_sabqa) - parseFloat(this.money);
                // this.push_importer_sadad(this.importer_sadad_table)
                this.all_importer_sadads[0] = this.importer_sadad_table1;

                // fatwora importer array[0]
                this.fatwora_importer_update1.id = this.fatworas[0].id;
                this.fatwora_importer_update1.remain = remain_to_first_fatwora;
                this.fatwora_importer_update1.sdad_status = "جاري السداد";
                this.fatwora_importer_update1.sdad_status_id = "2";
                this.all_importer_fatworas.push(this.fatwora_importer_update1);

                let khazna_fatwora_ = JSON.stringify(this.khazna_fatwora_table);
                let madionia_importer_ = JSON.stringify(
                  this.madionia_importer_table
                );
                let importer_sadad_ = JSON.stringify(this.all_importer_sadads);
                let importer_fatworas_ = JSON.stringify(
                  this.all_importer_fatworas
                );
                let khazina_ = JSON.stringify(this.khazina_update);

                this.do_sadad(
                  khazna_fatwora_,
                  madionia_importer_,
                  importer_sadad_,
                  importer_fatworas_,
                  khazina_
                );
              }
              // }else{
              //   this.$swal('Error','الرصيد غير كافي ' ,'Error');
              // }
            } else {
              if (parseFloat(this.the_madionia) > 0) {
                if (parseFloat(this.money) > parseFloat(this.the_madionia)) {
                  alert("قيمة السداد اكبر من المديونية ");
                } else {
                  let khazna_fatwora_ = JSON.stringify(
                    this.khazna_fatwora_table
                  );
                  let madionia_importer_ = JSON.stringify(
                    this.madionia_importer_table
                  );
                  let importer_sadad_ = JSON.stringify(
                    this.all_importer_sadads
                  );
                  let khazina_ = JSON.stringify(this.khazina_update);

                  this.do_sadad(
                    khazna_fatwora_,
                    madionia_importer_,
                    importer_sadad_,
                    null,
                    khazina_
                  );
                }
              } else {
                alert("المديونية صفر ولا يمكن عمل سداد للمورد هذا ");
              }
            }
          }
        } else {
          alert("رصيد الخزنة لا يكفي لعمل السداد");
        }
      }
    },
    do_sadad(
      khazna_fatwora_,
      madionia_importer_,
      importer_sadad_,
      importer_fatworas_,
      khazina_
    ) {
      this.loading = true;
      var frmData = new FormData();
      frmData.append("khazna_fatwora_table", khazna_fatwora_);
      frmData.append("madionia_importer_table", madionia_importer_);
      frmData.append("all_importer_sadads", importer_sadad_);
      frmData.append("all_importer_fatworas", importer_fatworas_);
      frmData.append("khazina_table", khazina_);
      frmData.append("importer_id", this.select_importer.id);
      add_importer_sadad(frmData).then(response => {
        this.$router.go(0);
        this.loading = false;
      });
    },

    delete_importer_sadad(item) {
      this.$swal({
        title: "هل تريد الأستمرار",
        text: "سيتم الحذف نهائيا ولا يمكن الرجوع",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم !",
        cancelButtonText: "لا"
      }).then(result => {
        if (result.value) {
          const index = this.sadads_fatworas.indexOf(item);

          this.loading = true;

          delete_importer_sadad(item.id).then(response => {
            this.loading = false;
            this.sadads_fatworas.splice(index, 1);
            this.close();
            this.$router.go(0);
          });
        }
      });
    },
    push_importer_sadad(sadad) {
      this.all_importer_sadads.push(sadad);
    },
    save(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (valid) {
          this.loading = true;
          this.newItem.code = this.code;
          this.newItem.branch_id = this.select_branch.id;
          var frmData = new FormData();
          frmData.append("bank", JSON.stringify(this.newItem));

          add_bank(frmData).then(response => {
            // Object.assign(this.$data.newItem, this.$options.data().newItem);
            // Object.assign(this.$data.select_branch, this.$options.data().select_branch);

            this.banks.push(response.data);
            this.loading = false;
            this.close();
            setTimeout(() => {
              this.$refs.form.reset();
            }, 1000);
          });
        }
      });
    },

    update(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (valid) {
          this.loading = true;
          let item_id = this.editedItem.id;

          this.editedItem.branch_id = this.select_branch_edit.id;
          var frmData = new FormData();
          frmData.append("bank", JSON.stringify(this.editedItem));
          update_bank(frmData, item_id).then(response => {
            Vue.set(
              this.banks,
              this.banks.findIndex(f => f.id === item_id),
              response.data
            );
            this.loading = false;
            this.close();
          });
        }
      });
    }
  }
};
</script>

<style scope>
.v-datatable__actions__range-controls {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
</style>
